import { plainToClass } from 'class-transformer';
import { ProjectFormDataTable } from './data-table';
import { CombinedProjectForm, DataTableProjectForm } from './project-form.entities';



export class ProjectFormDashboardPage {

    dataTable: any;
    combinedForms: CombinedProjectForm[];
    constructor(combinedFormsJSON: any, isAdmin: boolean, userEmail: string, isSO: boolean, isPO: boolean) {

        this.combinedForms = plainToClass(CombinedProjectForm, <CombinedProjectForm[]>combinedFormsJSON);
        let dataTableForms = [];
        this.combinedForms.forEach((form: CombinedProjectForm) => {
            let newDataTableForm = new DataTableProjectForm();
            newDataTableForm.initialize(form, isAdmin, userEmail, isSO, isPO);
            dataTableForms.push(newDataTableForm);
        });

        let formTable = new ProjectFormDataTable(dataTableForms);
        this.dataTable = formTable.dataTable;
    }

    newForm(): void {
        window.location.href = "/secure/project-form/project-form";
    }

}